import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoTiroides: [],
  },

  getters: {
    getTipoTiroides: (state) => state.tipoTiroides,
  },

  mutations: {
    SET_TIPO_TIROIDES(state, tipoTiroides) {
      state.tipoTiroides = tipoTiroides;
    },
  },

  actions: {
    async fetchTipoTiroides({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catTipoTiroides')
        .then((response) => {
          commit('SET_TIPO_TIROIDES', response.data.data);
        });
    },
  },
};
